import { render } from "./NewsDetailsPage.vue?vue&type=template&id=2362e2be"
import script from "./NewsDetailsPage.vue?vue&type=script&lang=js"
export * from "./NewsDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__